import {
  Box,
  Grid,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../Styles/strategy.css";
import HeaderIcons from "../../Images/headericon.png";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Loader";
import CoinbaseTabContent from "./Custodians/CoinbaseTabContent";
import moment from "moment";
import {
  GetUserCustodian,
  GetUserCustodianById,
  IBKRAccountdetails
} from "../../redux/Actions/userStatusService";

// Helper function to normalize custodian names for tab values
const normalizeCustodianName = (custodianName) => {
  return custodianName.toLowerCase().replace(/\s+/g, '-');
};

function ModifyUser() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const type = localStorage.getItem("type");
  const [Custodian, setCustodianData] = useState([]);
  const { userData, loading, userCust } = useSelector(
    (state) => state.userStatus
  );
  const [ibkrDetails, setIbkrDetails] = useState(null);
  const [userAccountId, setUserAccountId] = useState("");

  const [custodiansId, setCustodiansId] = useState();
  const [selectedTab, setSelectedTab] = useState(null);
  const [approvedCustodians, setApprovedCustodians] = useState([]);

  useEffect(() => {
    const findUser = userData?.find((i) => i.id == id);
    if (findUser) {
      setUser(findUser);
      
      const approvedStatuses = findUser?.kyc?.statuses?.filter(
        status => status.status === "APPROVED"
      ) || [];
      
      const approvedCustodianList = approvedStatuses.map(status => ({
        custodian: status.custodian,
        normalizedName: normalizeCustodianName(status.custodian)
      }));
      
      setApprovedCustodians(approvedCustodianList);
      
      // Auto-select first tab if none selected
      if (approvedCustodianList.length > 0 && !selectedTab) {
        setSelectedTab(approvedCustodianList[0].normalizedName);
      }
    } else {
      setUser(null);
      setApprovedCustodians([]);
      setSelectedTab(null);
    }
  }, [userData, id]);
  
  const userRoleId = user?.id;
  useEffect(() => {
    const fetchUserCustodian = async () => {
      if (!userRoleId) return;
      
      const response = await dispatch(GetUserCustodianById({ type, userRoleId }));
      if(response.payload.statusCode === 200) {
        setCustodianData(response?.payload?.data);
      
        if (selectedTab && response?.payload?.data) {
          // Match normalized tab name with custodian data
          const match = response.payload.data.find(cust => 
            normalizeCustodianName(cust.custodian) === selectedTab
          );
          
          if (match) {
            setCustodiansId(match.id);
            dispatch(GetUserCustodian(match.id));
          }
        }
      }
    };
    fetchUserCustodian();
  }, [dispatch, type, userRoleId, selectedTab]);

  useEffect(() => {
    // Fetch IBKR account details when user data is available
    const fetchIBKRDetails = async () => {
      if (user?.user?.email) {
        const response = await dispatch(IBKRAccountdetails());
        if (response?.payload?.statusCode === 200) {
          const ibkrData = response.payload.data;
          setIbkrDetails(ibkrData);
          
          // Filter IBKR accounts that match the user's email
          const userIBKRAccounts = ibkrData.filter(
            account => account.email === user.user.email
          );
          
          // Set the user's account ID if available
          if (userIBKRAccounts.length > 0) {
            setUserAccountId(userIBKRAccounts[0].accountId);
          } else {
            setUserAccountId("No IBKR Account Found");
          }
        }
      }
    };
    
    fetchIBKRDetails();
  }, [dispatch, user?.user?.email]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid item xs={12}>
          <Paper
            sx={{ p: 2, display: "flex", flexDirection: "column" }}
            elevation={1}
          >
            <div className="row rows" style={{ marginLeft: "2px" }}>
              <div className="col-1">
                <img
                  src={HeaderIcons}
                  alt="Header Icon"
                  width="45"
                  height="45"
                />
              </div>
              <div
                className="col-9"
                style={{ marginTop: "10px", marginLeft: "-3%" }}
              >
                <p style={{ fontSize: "20px", color: "#18275A" }}>
                  Investor Management
                </p>
              </div>
            </div>
          </Paper>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
            elevation={1}
          >
            <TextField
              label="Email"
              variant="outlined"
              disabled
              fullWidth
              value={user?.user?.email || ""}
              InputProps={{
                readOnly: true,
              }}
              margin="normal"
            />

            <TextField
              label="Registration Date"
              variant="outlined"
              disabled
              fullWidth
              value={
                user?.user?.createdAt
                  ? moment(user.user.createdAt).format("DD/MM/YYYY")
                  : ""
              }
              InputProps={{
                readOnly: true,
              }}
              margin="normal"
            />

            <TextField
              label="Account Type"
              variant="outlined"
              disabled
              fullWidth
              value={user?.investorType || ""}
              InputProps={{
                readOnly: true,
              }}
              margin="normal"
            />

            <TextField
              label="IBKR Account ID"
              variant="outlined"
              fullWidth
              value={userAccountId}
              InputProps={{
                readOnly: false,
              }}
              margin="normal"
            />
          </Paper>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
            elevation={1}
          >
            {approvedCustodians?.length === 0 ? (
              <Typography variant="subtitle1">
                No approved custodians for the user.
              </Typography>
            ) : (
              <>
                <Tabs
                  value={selectedTab || false}
                  onChange={(event, newValue) => {
                    setSelectedTab(newValue);
                    
                    const match = Custodian.find(cust => 
                      normalizeCustodianName(cust.custodian) === newValue
                    );
                    
                    if (match) {
                      setCustodiansId(match.id);
                      dispatch(GetUserCustodian(match.id));
                    }
                  }}
                  sx={{
                    mb: 3,
                    '& .MuiTabs-root': {
                      minHeight: 48,
                    },
                    '& .MuiTab-root': {
                      textTransform: 'none',
                      fontWeight: 500,
                      fontSize: '0.95rem',
                      minHeight: 48,
                      padding: '12px 24px',
                      margin: '0 8px',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      backgroundColor: '#f9f9f9',
                      color: '#666',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: '#f0f0f0',
                        borderColor: '#18275A',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                        transform: 'translateY(-1px)',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#1876d2',
                        color: '#fff',
                        borderColor: '#18275A',
                        boxShadow: '0 4px 12px rgba(24, 39, 90, 0.3)',
                        fontWeight: 600,
                      },
                    },
                    '& .MuiTabs-indicator': {
                      display: 'none', // Hide the default indicator since we're using custom styling
                    },
                    '& .MuiTabs-flexContainer': {
                      gap: '8px',
                      justifyContent: 'flex-start',
                      flexWrap: 'wrap',
                    },
                  }}
                >
                  {approvedCustodians.map((custodian) => (
                    <Tab
                      key={custodian.normalizedName}
                      label={custodian.custodian}
                      value={custodian.normalizedName}
                    />
                  ))}
                </Tabs>

                {selectedTab ? (
                  <Box value={selectedTab}>
                    <CoinbaseTabContent 
                      user={Custodian} 
                      userCust={userCust} 
                      custId={custodiansId} 
                      selectedTab={selectedTab}
                      userAccountId={userAccountId}
                      onAccountIdChange={setUserAccountId}
                    />
                  </Box>
                ) : (
                  <Box sx={{ p: 3, textAlign: 'center', mt:-5 }}>
                    <Typography variant="body1" color="text.secondary">
                      Please select a custodian details to view
                    </Typography>
                  </Box>
                )}
              </>
            )}
          </Paper>
        </Grid>
      )}
    </>
  );
}

export default ModifyUser;
